var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4301 16.51L19.026 20.1941L20.0928 19.1013L5.15944 3.80204L4.09277 4.89484L8.32153 9.22721V10.4526C8.32153 12.5864 10.01 14.3162 12.0928 14.3162C12.4566 14.3162 12.8083 14.2635 13.1412 14.1649L14.3104 15.3628C13.6361 15.683 12.8848 15.8617 12.0928 15.8617C9.43293 15.8617 7.23249 13.8466 6.86651 11.2253H5.34598C5.6938 14.4488 8.19209 17.0083 11.3385 17.3647V20.498H12.847V17.3647C13.7777 17.2593 14.6517 16.9611 15.4301 16.51ZM11.7553 12.7452C10.7758 12.5951 10.0015 11.8019 9.85501 10.7982L11.7553 12.7452ZM17.655 14.4402L16.5671 13.3255C16.9505 12.7 17.2125 11.9883 17.319 11.2253H18.8395C18.7114 12.4127 18.2916 13.5099 17.655 14.4402ZM15.461 12.1923L14.293 10.9958C14.3339 10.8216 14.3555 10.6397 14.3555 10.4526V7.36168C14.3555 6.08139 13.3424 5.0435 12.0928 5.0435C11.1166 5.0435 10.2848 5.6768 9.96746 6.56424L8.83864 5.40776C9.49371 4.26512 10.7058 3.49805 12.0928 3.49805C14.1756 3.49805 15.864 5.22786 15.864 7.36168V10.4526C15.864 11.0784 15.7188 11.6695 15.461 12.1923Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicPermission);
export default __webpack_public_path__ + "static/media/MicPermission.4bef8a1e56671c06d67825cb1c79c343.svg";
export { ForwardRef as ReactComponent };